export const AdminCallCenterDashboards = {
  AdminCallCenterDashboards: 
  {
    permissionsId: '612750e1-f9ac-4055-ee3e-08da65738802',
    permissionsName: 'Admin Call Center Team',
    componentsId: null,
    components: null
  }
} ;
